import localStorageAvailable from "../../utils/localStorageAvailable";
import axios from "../../utils/axios";
import { enqueueSnackbar } from "notistack";

const getEventsDiscountDetails = async (user, handle, logout) => {
  const storageAvailable = localStorageAvailable();
  const accessToken = storageAvailable
    ? localStorage.getItem("accessToken")
    : "";
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `/service/events_service/v1/events/discount-coupon/coupon/${handle}`,
    headers: {
      authorization: `Bearer ${accessToken}`,
      user,
    },
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.log(error,"error");
    
    if (error?.data === "Verification timeout") {
      return;
    }
    if (error?.status === 401) {
      enqueueSnackbar("Un Authorized Request", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      logout();
    }
    enqueueSnackbar(error?.data?.message || error?.data, {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
  }
};

export default getEventsDiscountDetails;
